import { render, staticRenderFns } from "./TaskCreatedMentionNotification.vue?vue&type=template&id=1a04acf4"
import script from "./TaskCreatedMentionNotification.vue?vue&type=script&lang=js"
export * from "./TaskCreatedMentionNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports